import * as React from "react";
import { Box, Stack } from "@mui/material";
import { colors } from "@/styles/constants";
import { AccountType, YesNo } from "@/types";
import { Responsible } from "./Responsible";
import { FieldRow, FieldsTable } from "@/components/molecules/FieldsTable";
import { PropertySummary } from "./PropertySummary";
import { readableAccountNextSteps, readableAccountType } from "@/utils/accounts";
import { AccountDisplayInfo } from "./AccountDetails";

export const InsuranceAccount: React.FC<AccountDisplayInfo> = ({
  properties,
  persons,
  account: {
    propertyId,
    serviceProviderType,
    accountNumber,
    holderNumber,
    accountType,
    accountTypeOther,
    vehicleMake,
    vehicleModel,
    vehicleRegistrationNumber,
    jointClaim,
    nextSteps,
    responsibleId,
  },
  documents,
}) => {
  return (
    <FieldsTable>
      <FieldRow label="Policy number" value={accountNumber} />
      <FieldRow label="Customer reference" value={holderNumber} />
      <FieldRow label="Policy type" value={readableAccountType(accountType, accountTypeOther)} />
      {(accountType === AccountType.Vehicle || accountType === AccountType.BreakdownCover) && (
        <>
          <FieldRow label="Vehicle make" value={vehicleMake} />{" "}
          <FieldRow label="Vehicle model" value={vehicleModel} />
          <FieldRow label="Vehicle registration" value={vehicleRegistrationNumber} />
        </>
      )}
      <FieldRow
        label="Property"
        value={<PropertySummary properties={properties} propertyId={propertyId} />}
      />
      <FieldRow label="Joint policy?" value={jointClaim === YesNo.Yes ? "Yes" : "No"} />
      <FieldRow
        label="Next step"
        value={readableAccountNextSteps(nextSteps, serviceProviderType)}
      />
      <FieldRow
        label="Responsible"
        value={<Responsible persons={persons} responsibleId={responsibleId} />}
      />
      {documents && documents.length > 0 && (
        <FieldRow
          label="Documents"
          value={
            <Stack>
              {documents.map((doc, index) => (
                <Box key={index}>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={doc.downloadUrl}
                    style={{ color: colors.primary }}
                  >
                    {doc.filename}
                  </a>
                </Box>
              ))}
            </Stack>
          }
        />
      )}
    </FieldsTable>
  );
};
